/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TrustCommercesubscriptionsSubscription from './TrustCommercesubscriptionsSubscription';

/**
 * The SubscriptionsCancelBody model module.
 * @module model/SubscriptionsCancelBody
 * @version v0.3
 */
export default class SubscriptionsCancelBody {
  /**
   * Constructs a new <code>SubscriptionsCancelBody</code>.
   * @alias module:model/SubscriptionsCancelBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SubscriptionsCancelBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SubscriptionsCancelBody} obj Optional instance to populate.
   * @return {module:model/SubscriptionsCancelBody} The populated <code>SubscriptionsCancelBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SubscriptionsCancelBody();
      if (data.hasOwnProperty('subscription'))
        obj.subscription = TrustCommercesubscriptionsSubscription.constructFromObject(data['subscription']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TrustCommercesubscriptionsSubscription} subscription
 */
SubscriptionsCancelBody.prototype.subscription = undefined;

